import RouteTemplate from 'ember-route-template';

export default RouteTemplate(
  <template>
    <section class="pd-best-for">
      <div class="pd-best-for__hero">
        <a class="pd-best-for__back" href="/providers">← All locations</a>
        <h1 class="pd-best-for__title">Best Proxies in {{@controller.model.location}}</h1>
        <p class="pd-best-for__subtitle">
          Top-rated proxy providers with servers available in {{@controller.model.location}}.
        </p>
      </div>
    
      <div class="pd-best-for__ranked-list">
        {{#each @controller.model.providers as |p|}}
          <a class="pd-best-for__rank-item {{p.rankClass}}" href={{p.url}}>
            <div class="pd-best-for__rank-num">{{p.rank}}</div>
            <div class="pd-best-for__logo">
              {{#if p.logo_url}}
                <img src={{p.logo_url}} alt={{p.name}} class="pd-best-for__logo-img" loading="lazy" />
              {{else}}
                <span class="pd-card__logo-placeholder">{{p.logoInitial}}</span>
              {{/if}}
            </div>
            <div class="pd-best-for__details">
              <h3 class="pd-best-for__provider-name">{{p.name}}</h3>
              <div class="pd-best-for__provider-meta">
                <span>★ {{p.ratingDisplay}}</span>
                <span>{{p.costDisplay}}</span>
                <span>{{p.proxy_type}}</span>
              </div>
              {{#if p.hasRegionalData}}
                <div class="pd-best-for__regional-perf" title="Averaged from {{p.runCount}} benchmark run(s) in this region">
                  <span class="pd-best-for__regional-perf-label">Regional performance:</span>
                  <span>{{p.responseTimeDisplay}} avg</span>
                  <span>{{p.successRateDisplay}} success</span>
                  <span>{{p.uptimeDisplay}} uptime</span>
                </div>
              {{else}}
                <div class="pd-best-for__regional-perf pd-best-for__regional-perf--none">
                  No benchmark data for this region yet — ranked by overall rating.
                </div>
              {{/if}}
            </div>
            <span class="pd-best-for__cta">View →</span>
          </a>
        {{else}}
          <div class="pd-empty">
            <div class="pd-empty__icon">🌍</div>
            <div class="pd-empty__title">No providers in {{@controller.model.location}} yet</div>
            <div class="pd-empty__body">Providers with servers in this location will appear here once listed.</div>
          </div>
        {{/each}}
      </div>
    </section>

  </template>
);
